module.exports = __webpack_public_path__ + "static/media/TravelerGuidelines.1dbf03ac.pdf";